'use client';
import { RenderAd } from '@pickleballinc/ui/components/advertisements/render-ad';
import { RenderFloatingAd } from '@pickleballinc/ui/components/advertisements/render-floating-ad';

import { IS_PRODUCTION } from '@/components/constants/constants';
import { ZONE_IDS_PTL } from '@/lib/ads.types';
import { PLACEMENT_IDS_PTL } from '@/lib/freestar.ptl.types';
import { useLocation } from '@/lib/location/location';
export const AdvertisementGallery = () => {
	const { location } = useLocation();

	return (
		<>
			<RenderAd
				placementId={PLACEMENT_IDS_PTL.siderail_right_team_leagues}
				zoneId={ZONE_IDS_PTL.PROG_LONG_CARD}
				pageId={100005}
				place={0}
				ipAddress={location?.query}
				containerClassname="w-[300px] pt-4 md:pt-6"
				showFromWidth={1024}
				isProd={IS_PRODUCTION}
				width={320}
			/>
			<RenderFloatingAd
				placementId={PLACEMENT_IDS_PTL.siderail_right_team_leagues}
				zoneId={ZONE_IDS_PTL.HOUSE_LONG_CARD}
				pageId={100005}
				place={1}
				width={300}
				height={600}
				ipAddress={location?.query}
				showFromWidth={1024}
				isProd={IS_PRODUCTION}
				className="w-[300px] pt-4 md:pt-6 sticky top-[200px]"
			/>
		</>
	);
};
